export var ArticleClass;
(function (ArticleClass) {
    ArticleClass["GALLERY"] = "Gallery";
    ArticleClass["VIDEO"] = "Video";
    ArticleClass["ARTICLE"] = "Article";
})(ArticleClass || (ArticleClass = {}));
//# sourceMappingURL=article.js.map